<template>
<div>
   <div class="yo-fixed-top" style="top:132px;z-index:999;">
   <div class="row el-container" style="background:#fff;padding:16px 20px;">
      <div class="col s6">
         <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-breadcrumb-item :to="{ path: '/home' }">{{$centro.profile.row.nome}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="item.row.id<1">NUOVO PAZIENTE</el-breadcrumb-item>
         <el-breadcrumb-item v-if="item.row.id>0">{{item.row.datanascita | data('YYYY')}}-{{item.row.ncartellaclinica}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="item.row.id>0">{{item.row.cognome}} {{item.row.nome}}</el-breadcrumb-item>
         <el-breadcrumb-item>{{titolo}}</el-breadcrumb-item>
         </el-breadcrumb>
      </div>
      <div class="col s6 yo-align-right">
         <div class="row" v-if="item.row.id>0">
            <div class="col s12" style="">

               <router-link v-if="scheda!=6 && item.row.fdisp==2" class="button yo-color-primary yo-text-bold" :to="'/scheda-trasferimento/'+item.row.id" >
               <el-popover placement="top" title="Trasferimento" trigger="hover">
               <i slot="reference" class="material-icons " style="float:right;padding:0 12px 0 18px;" >directions_bus</i>
               </el-popover>  
               </router-link>

               <router-link v-if="scheda!=5" class="button yo-color-primary yo-text-bold" :to="'/scheda-dimissione/'+item.row.id" >
               <el-popover placement="top" title="Dimissione" trigger="hover">
               <i slot="reference" class="material-icons " style="float:right;padding:0 12px 0 18px;" >child_friendly</i>
               </el-popover>  
               </router-link>

               <router-link v-if="scheda!=4" class="button yo-color-primary yo-text-bold" :to="'/scheda-decorso/'+item.row.id" >
               <el-popover placement="top" title="Decorso Clinico" trigger="hover">
               <i slot="reference" class="material-icons " style="float:right;padding:0 12px 0 18px;" >hotel</i>
               </el-popover>  
               </router-link>

               <router-link v-if="scheda!=3" class="button yo-color-primary yo-text-bold" :to="'/scheda-salaparto/'+item.row.id" >
               <el-popover placement="top" title="Sala Parto" trigger="hover">
               <img slot="reference" src="../assets/ico-salaparto.png" class="material-icons " style="float:right;padding:0 12px 0 18px;height:24px;"  />
               </el-popover>  
               </router-link>

               <router-link v-if="scheda!=2" class="button yo-color-primary yo-text-bold" :to="'/scheda-perinatale/'+item.row.id" >
               <el-popover placement="top" title="Dati Perinatali" trigger="hover">
               <img slot="reference" src="../assets/ico-perinatale.png" class="material-icons " style="float:right;padding:0 12px 0 18px;height:24px;" />
               </el-popover>  
               </router-link>

               <router-link v-if="scheda!=1" class="button yo-color-primary yo-text-bold" :to="'/scheda-datigenerali/'+item.row.id" >
               <el-popover placement="top" title="Dati Generali" trigger="hover">
               <i slot="reference" class="material-icons " style="float:right;padding:0 12px 0 18px;" >folder_open</i>
               </el-popover>  
               </router-link>

               
               

            </div>

          </div>


      </div>
   </div>
   </div>

   <div v-if="item.row.chiusoil!='0000-00-00 00:00:00'" class="yo-text-l white yo-align-center" style="background:#F73D3D;padding:32px 0;margin-bottom:16px;">
      La scheda risulta chiusa il
   <div class="yo-text-xxl yo-text-bold yo-text-uppercase">
      {{item.row.chiusoil  | data('DD MMMM YYYY \\A\\L\\L\\E \\O\\R\\E  HH:mm')}}
   </div>
non è quindi possibile salvare alcuna modifica
   
   </div>
</div>
</template>

<script>
export default {
   props: ['scheda','titolo','item']
}
</script>
